import { Setting } from "src/types"

export const getBoolValueFromSetting = (setting: Setting | undefined) =>
  typeof setting?.value !== "undefined" ? setting.value === "true" : undefined

export const getNumberValueFromSetting = (setting: Setting | undefined) =>
  typeof setting?.value !== "undefined" ? +setting.value : undefined
